import React, { useState } from "react";
import "../Styles/MobileTopup.css";
import VendorFormModal from "../components/VendorFormModal";
import { useNavigate } from "react-router-dom";


const MobileTopup = () => {
  const [expanded, setExpanded] = useState(false);
  const [showVendorForm, setShowVendorForm] = useState(false);
  const navigate = useNavigate();

  const vendors = [
    { alias: "Avis Retemiah", product: "Top-Up", number: "+592 633 0786", location: "Arthurville W/naam" },
    { alias: "Chabi Laylys", product: "Top-Up", number: "+592 682 3136", location: "Noitgedacht W/naam" },
    { alias: "Sharmele Singh", product: "Top-Up", number: "+592 691 4264", location: "Melville W/naam" },
    { alias: "Hameraj & Sons", product: "Phone Cards", number: "+592 669-1025", location: "MeerZorg W/naam" },
    { alias: "Mokesh", product: "Phone Cards", number: "+592 698 5772", location: "Zeelandia W/naam" },
    { alias: "Cindy Gordon", product: "Top-Up", number: "+592 ---", location: "Sans Souci W/naam" },
    { alias: "Naimoon", product: "Phone Cards", number: "+592 ---", location: "Sarah W/naam" },
    { alias: "Babes", product: "Phone Cards", number: "+592 ---", location: "Belle W/naam" },
    { alias: "Devina", product: "Phone Cards", number: "+592 ---", location: "Caledonia W/naam" },
  ];

  const visibleRows = expanded ? vendors : vendors.slice(0, 5);

  return (

    <div className="mobile-topup-page">

<button
  className="back-button"
  onClick={() => navigate("/services")}
>
  ⬅ Back to Services
</button>

      <div className="header-container">
        <h2>📲 Mobile Top-Up</h2>
      </div>

      <p>
        Top-up for Digicel, One Communication (formorely GTT), and Enet is available in both retail and wholesale.
        Visit us in-store or contact us for bulk rates. 
        <br /><br />
        Phone cards for One Communication (formorely GTT) and Digicel, also available in retail and wholesale quantities.
      </p>

      <div className="vendor-section-wrapper">
        <div className="section-container">
          <h3>📋 List of Vendors</h3>
          <p>
           RCS has an ever growing base of vendors strategically at various villages in the Island of Wakenaam, which makes
           it easy and convenient for customers to access services such as mobile topup or phone cards. 
          </p>

          <table className="vendor-table">
            <thead>
              <tr>
                <th>Alias</th>
                <th>Product</th>
                <th>Contact Number</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {visibleRows.map((v, i) => (
                <tr key={i}>
                  <td>{v.alias}</td>
                  <td>{v.product}</td>
                  <td>{v.number}</td>
                  <td>{v.location}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <button className="toggle-button" onClick={() => setExpanded(!expanded)}>
            {expanded ? "View Less" : "View More"}
          </button>
        </div>

        <div className="section-container">
          <h3>📝 Vendor Sign Up</h3>
          <p>
            Want to become a vendor? Sign up to join our reseller network and enjoy wholesale rates,
            financing options, and dedicated support.
            <br /><br />
            Earn commission on topup sales at your convenience, be your own boss and start selling today!
            <br /><br />
            Click the sign up form below to become a vendor
            <br /><br />
            <strong>PLEASE HAVE YOUR ID AND TIN OR DRIVER'S LICENCE READY BEFORE FULLING THIS FORM!</strong>
          </p>
          <button className="toggle-button" onClick={() => setShowVendorForm(true)}>
  Sign Up
</button>

        </div>
      </div>
      {showVendorForm && <VendorFormModal onClose={() => setShowVendorForm(false)} />}
    </div>
  );
};

export default MobileTopup;
